// PDF React View
import { yupResolver } from "@hookform/resolvers/yup";
import {
  MODE_INVOICE_ACTION,
  TYPE_ADJUST_INVOICE,
} from "constants/IssueInvoiceConstant";
import { english } from "flatpickr/dist/l10n/default";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import {
  generateDateField,
  generateInputField,
  generateSelectField,
} from "helpers/form_helper_old";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as yup from "yup";
import { initOptionDateLocale } from "../utils";
const ConfirmActionInvoiceTT32 = props => {
  const dispatch = useDispatch();
  const { isOpen, toggle, confirmActionData, actionReplaceOrAdjustInvoice } =
    props;

  const [optionDateLocale, setOptionDateLocale] = useState({
    ...initOptionDateLocale,
  });

  const { t, i18n } = useTranslation(["issueInvoice"]);

  const issueInvoice = useSelector(state => state.issueInvoice);
  const { currentTime } = issueInvoice;
  // Language Change
  useEffect(() => {
    const lang = i18n.language;
    const currentDate = new Date();
    const defaultMaxDate = moment(currentDate.getTime()).format("DD-MM-YYYY");
    switch (lang) {
      case "vn":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...Vietnamese,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
          maxDate: defaultMaxDate,
        });
        break;
      case "en":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...english,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      default:
        break;
    }
  }, [t]);

  useEffect(() => {
    if (isOpen) {
      const defaultMaxDate = currentTime?.data?.momentDate.format("DD-MM-YYYY");
      setOptionDateLocale({
        ...optionDateLocale,
        maxDate: defaultMaxDate,
      });
      switch (confirmActionData.mode) {
        case MODE_INVOICE_ACTION.REPLACE:
          setValue("isAdjust", false);
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          setValue("isAdjust", true);
          break;
        default:
          break;
      }
    } else {
      reset();
    }
  }, [isOpen]);

  const schema = yup.object().shape({
    isAdjust: yup.boolean(),
    pattern: yup
      .string()
      .required("Vui lòng chọn mẫu số")
      .max(11, t("form.validate.char_max", { max: 11 })),
    serial: yup
      .string()
      .required("Vui lòng chọn ký hiệu")
      .max(8, t("form.validate.char_max", { max: 8 })),
    invoiceNo: yup
      .string()
      .required("Vui lòng nhập số hóa đơn")
      .max(8, t("form.validate.char_max", { max: 8 })),
    note: yup.string(),
    nlap: yup.array().min(1, "VUi lòng chọn ngày lập"),
    typeAdjust: yup.object().when("isAdjust", {
      is: true, //just an e.g. you can return a function
      then: yup.object().required("Vui lòng chọn kiểu điều chỉnh"),
    }),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      nlap: [],
      pattern: "",
      serial: "",
      invoiceNo: "",
      note: "",
    },
  });

  const onSubmit = values => {
    let typeAdjust = null;
    typeAdjust = values?.typeAdjust?.value;
    toggle();
    switch (confirmActionData.mode) {
      case MODE_INVOICE_ACTION.REPLACE:
        break;
      case MODE_INVOICE_ACTION.ADJUST:
        break;
      default:
        break;
    }
    const data = {
      infoTT32: {
        tthdlquan_gchu: values?.note,
        tthdlquan_shdclquan: values?.invoiceNo,
        tthdlquan_khmshdclquan: values?.pattern,
        tthdlquan_nlhdclquan: moment(values?.nlap?.[0]).format("YYYY-MM-DD"),
        tthdlquan_khhdclquan: values?.serial,
        modeTT32: typeAdjust
          ? MODE_INVOICE_ACTION.ADJUST
          : MODE_INVOICE_ACTION.REPLACE,
        text: typeAdjust ? "điều chỉnh" : "thay thế",
        typeAdjust,
      },
    };
    actionReplaceOrAdjustInvoice(data);
  };

  const optionTypeAdjust = [
    {
      value: TYPE_ADJUST_INVOICE.INCREASE,
      label: "Hóa đơn điều chỉnh tăng",
    },
    {
      value: TYPE_ADJUST_INVOICE.DECREASE,
      label: "Hóa đơn điều chỉnh giảm",
    },
    {
      value: TYPE_ADJUST_INVOICE.CHANGE_INFO,
      label: "Hóa đơn điều chỉnh thông tin",
    },
  ];

  return (
    <Modal
      size="sm"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ maxWidth: "400px" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>
            Thông tin hóa đơn TT32 cần{" "}
            {confirmActionData?.mode === MODE_INVOICE_ACTION.REPLACE
              ? "thay thế"
              : "điều chỉnh"}
          </Label>
        </ModalHeader>

        <React.Fragment>
          <ModalBody>
            <React.Fragment>
              <Row>
                <Col>
                  {generateInputField(
                    "Mẫu số",
                    true,
                    "text",
                    errors,
                    touchedFields,
                    "pattern",
                    "Vui lòng nhập Mẫu số",
                    register,
                    false
                  )}
                </Col>
              </Row>
              <Row className="mt-1">
                <Col>
                  {generateInputField(
                    "Ký hiệu",
                    true,
                    "text",
                    errors,
                    touchedFields,
                    "serial",
                    "Vui lòng nhập Ký hiệu",
                    register,
                    false
                  )}
                </Col>
              </Row>
              <Row className="mt-1">
                <Col>
                  {generateInputField(
                    "Số hóa đơn",
                    true,
                    "text",
                    errors,
                    touchedFields,
                    "invoiceNo",
                    "Vui lòng nhập Số hóa đơn",
                    register,
                    false
                  )}
                </Col>
              </Row>
              <Row className="mt-1">
                <Col>
                  {generateDateField(
                    "Ngày lập",
                    "",
                    true,
                    errors,
                    "nlap",
                    "DD/MM/YYYY",
                    false,
                    control,
                    optionDateLocale
                  )}
                </Col>
              </Row>
              <Row className="mt-1">
                <Col>
                  {generateInputField(
                    "Ghi chú",
                    false,
                    "textarea",
                    errors,
                    touchedFields,
                    "note",
                    "Vui lòng nhập Ghi chú",
                    register,
                    false
                  )}
                </Col>
              </Row>
              {confirmActionData?.mode === MODE_INVOICE_ACTION.ADJUST && (
                <Row className="mt-1">
                  <Col>
                    {generateSelectField(
                      "Kiểu điều chỉnh",
                      true,
                      errors,
                      "typeAdjust",
                      "Vui lòng chọn kiểu điều chỉnh",
                      false,
                      control,
                      optionTypeAdjust,
                      "auto"
                    )}
                  </Col>
                </Row>
              )}
            </React.Fragment>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="primary"
              // disabled={listMethodSign.length === 0}
              className="me-2 btn-label"
              onClick={() => {
                handleSubmit(onSubmit)();
              }}
            >
              {confirmActionData?.mode === MODE_INVOICE_ACTION.REPLACE ? (
                <React.Fragment>
                  <i className="bx bx-rotate-left label-icon" />
                  Thay thế hóa đơn
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <i className="bx bx-edit label-icon" />
                  Điều chỉnh hóa đơn
                </React.Fragment>
              )}
            </Button>
            <Button
              type="button"
              color="danger"
              className="me-2"
              onClick={toggle}
            >
              Đóng
            </Button>
          </ModalFooter>
        </React.Fragment>
      </div>
    </Modal>
  );
};

ConfirmActionInvoiceTT32.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  confirmActionData: PropTypes.any,
  actionReplaceOrAdjustInvoice: PropTypes.func,
};

export default ConfirmActionInvoiceTT32;
